// import logotipo from '../../../../../assets/logo.png'
import View from '../../../components/configPdf/View'
import Text from '../../../components/configPdf/Text'
import CustomTablePDF from '../../../components/configPdf/CustomTablePDF'
import { Page, Document, PDFViewer } from '@react-pdf/renderer'
import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { requestDefaulAuth } from '../../../http/httpRequest'
import { TitleTable } from '../../../components/configPdf/TitleTable'
import { formatDateNumberWithTime } from '../../../utils/dateFormat'

const CompraPdf = ({ compraId, viewAmount }) => {
  const [data, setData] = useState({})
  const [loading, setLoading] = useState(true)
  const params = useParams()
  const dipatch = useDispatch()

  const getData = async () => {
    setLoading(true)
    await requestDefaulAuth(
      'get',
      `/compra/${compraId}/fullDetail`,
      null,
      setData,
      dipatch
    )
    setLoading(false)
  }

  const DataLabels1 = [
    { label: 'Precinto:', value: data?.precinto },
    { label: 'Almacén:', value: data?.almacen_nombre },
    { label: 'Proveedor:', value: data?.almacen_proveedor_nombre },
    { label: 'Transportista:', value: data?.transportista_nombre },
    { label: 'Solicitud:', value: formatDateNumberWithTime(data?.fecha_solicitud) },
    { label: 'Confirmación de compra:', value: formatDateNumberWithTime(data?.fecha_confirmacion_compra) },
    { label: 'Confirmación de salida:', value: formatDateNumberWithTime(data?.fecha_confirmacion_salida) },
    { label: 'Llegada al proveedor:', value: formatDateNumberWithTime(data?.fecha_entrega_proveedor) },
    { label: 'Salida del proveedor:', value: formatDateNumberWithTime(data?.fecha_planificacion_llegada) },
    { label: 'Conclusión:', value: formatDateNumberWithTime(data?.fecha_fin) },
  ]
  const DataLabels2 = [
    ...(
      viewAmount ?
        [
          { label: 'Compra bs.:', value: data?.monto_compra?.toLocaleString('es-BO', { minimumFractionDigits: 2 }) },
          { label: 'Flete bs.:', value: data?.monto_flete?.toLocaleString('es-BO', { minimumFractionDigits: 2 }) },
          { label: 'Otros gastos bs.:', value: data?.monto_otros?.toLocaleString('es-BO', { minimumFractionDigits: 2 }) },
          { label: 'Total bs.:', value: data?.monto?.toLocaleString('es-BO', { minimumFractionDigits: 2 }) },
        ]
        :
        []
    ),
    { label: 'Obs. solicitud de compra:', value: data?.obs_solicitud_compra },
    { label: 'Obs. confirmación de compra:', value: data?.obs_confirmacion_compra },
    { label: 'Obs. confirmación de salida:', value: data?.obs_confirmacion_salida },
    { label: 'Obs. distribución de envases:', value: data?.obs_distribucion_envase },
    { label: 'Obs. cantidad de retorno:', value: data?.obs_cantidad_retorno },
    { label: 'Obs. confirmación de llegada:', value: data?.obs_confirmacion_llegada },
  ]
  useEffect(() => {
    getData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params.cuaderno_id])
  const MyDoc = (
    <Document>
      <Page size='LETTER' style={{ padding: '10px' }}>
        {/* <Page size={{ width: 226.77, height: 'auto' }} style={{ padding: '10px' }}> */}
        <View
          alignItems='flex-start'
        >
          <View
            width='100%'
            style={{ marginRight: '5px', paddingRight: '25px', paddingLeft: '25px' }}
            flexDirection='column'
          >
            <View margin='auto' style={{ marginBottom: '20px' }}>
              <Text bold fontSize='12px' style={{ letterSpacing: '2px' }}>PLANILLA DE COMPRA</Text>
            </View>
            <View>
              <View flexDirection='column' width='50%'>
                {
                  DataLabels1.map((i, idx) => (
                    <View key={idx}>
                      <Text fontSize='8px' textAlign='right'>{i.label} {i.value}</Text>
                    </View>
                  ))
                }
              </View>
              <View flexDirection='column' width='50%'>
                {
                  DataLabels2.map((i, idx) => (
                    <View key={idx}>
                      <Text fontSize='8px' textAlign='right'>{i.label} {i.value}</Text>
                    </View>
                  ))
                }
              </View>
            </View>
            <TitleTable
              margin='20px 0px 0px 0px'
              textTitle='RETORNO DE ITEMS'
            />
            <CustomTablePDF
              fields={[
                {
                  label: 'PRODUCTO',
                  name: 'etiqueta',
                  // type: 'date',
                  width: '50%',
                },
                {
                  label: 'CANTIDAD',
                  name: 'cantidad',
                  width: '50%',
                  justifyContent: 'flex-end'
                },
              ]}
              border={{ right: true, bottom: true, left: true }}
              data={data.retornoMap}
            />
          </View>
        </View>
        <View
          margin='50px 0 0 0'
          justifyContent='center'
        >
          <View
            width='25%'
            style={{ marginRight: '5px' }}
          >
            <View width='100%' flexDirection='column'>
              <View justifyContent='center'>
                <Text>
                  ...........................................
                </Text>
              </View>
              <View justifyContent='center'>
                <Text>
                  COMPRADOR
                </Text>
              </View>
            </View>
          </View>
          <View
            width='25%'
            style={{ marginRight: '5px' }}
          >
            <View width='100%' flexDirection='column'>
              <View justifyContent='center'>
                <Text>
                  ...........................................
                </Text>
              </View>
              <View justifyContent='center'>
                <Text>
                  VENDEDOR
                </Text>
              </View>
            </View>
          </View>
        </View>
      </Page>
    </Document>
  )

  return (
    loading ?
      <div className='mx-16 my-12'>
        <div>
          <svg aria-hidden='true' className='inline w-14 h-14 text-gray-200 animate-spin dark:text-gray-500 dark:fill-yellow-500 fill-yellow-600' viewBox='0 0 100 101' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <path d='M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z' fill='currentColor' />
            <path d='M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z' fill='currentFill' />
          </svg>
          <span className='sr-only'>Loading...</span>
        </div>
      </div>
      :
      <PDFViewer
        style={{
          width: 900,
          height: window.innerHeight - 100,
        }}
        children={MyDoc}
      />
  )
}

export default CompraPdf